"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'boolean': [
        'a11y',
        'animateFill',
        'arrow',
        'autoFocus',
        'flip',
        'inertia',
        'interactive',
        'lazy',
        'livePlacement',
        'multiple',
        'performance',
        'showOnInit',
        'sticky',
        'touch',
        'touchHold',
    ],
    'string': [
        'animation',
        'aria',
        'arrowType',
        'boundary',
        'placement',
        'size',
        'target',
        'theme',
        'trigger',
    ],
    'string,string[]': [
        'flipBehavior',
    ],
    'number': [
        'distance',
        'interactiveBorder',
        'interactiveDebounce',
        'updateDuration',
        'zIndex',
    ],
    'number,number[]': [
        'delay',
        'duration',
    ],
    'Function': [
        'onHidden',
        'onHide',
        'onMount',
        'onShow',
        'onShown',
        'shouldPopperHideOnBlur',
    ],
    'object': [
        'popperOptions',
    ],
    'number,string': [
        'maxWidth',
        'offset',
    ]
};
